<template>
<div class="menuBody" >
    <choiceTree @CheckD="getMsgFormSon"/>
        <BillStorageDialog :param="diaLogData" ref="BillStorageDialog"/>
    <div class="menuTool" style="width:100%;">
      <el-card class="box-card">
        <el-row :gutter="10">
            <div style="width:100%;height:30px;margin-top:10px;border-bottom:1px solid rgba(234, 237, 241, 1);margin-bottom:15px">
                账单列表<!--  应收账单生成  -->
                <div style="float:right;margin-right:10px;margin-top:-10px">
                    <el-button type="primary" size="small" plain style="background: #38A38A;color:#fff;border-radius:9px;" v-Jurisdiction="'expense:web:cp:bg:getfee'"  @click="CreateBill()">生成账单</el-button>
                </div>
            </div>
            <div style="width:300px;float:left;margin-right:15px;">
                <el-date-picker size="small" style="width:300px;" v-model="BillDateVal" type="monthrange"
                start-placeholder="开始月份" end-placeholder="结束月份" @change="BillDate"></el-date-picker>
            </div>
            <div style="width:150px;float:left;margin-right:15px;">
                 <el-cascader size="small" style="color:black" :options="ChargeItemList" :props="props" collapse-tags clearable 
                  @change="ChargeItemL" placeholder="请选择收费项目"></el-cascader>
            </div>
            <div style="width:150px;float:left;margin-left:15px;">
              <el-cascader size="small"  :options="HouseNatureList" :props="propss" collapse-tags clearable 
                  @change="ChanHouseNature" placeholder="请选择房屋性质"></el-cascader>
            </div>
  <el-table  :data="tableData" tooltip-effect="light"  v-loading="loading"  @selection-change="BillNucleu" 
  style="overflow-y: scroll;float:right;margin-top:30px" row-key="id"   :header-cell-style="{background:'#eef1f6',color:'#606266','font-weight': '600','height':'45px','text-align':'left'}" 
      :cell-style="{'text-align':'left'}"  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
    <el-table-column type="selection" width="55" style="text-align: center;"></el-table-column>
    <el-table-column prop="roomName" label="房间号"  ></el-table-column>
    <el-table-column prop="buildArea" label="面积"  ></el-table-column>
    <el-table-column prop="name" label="业主姓名"  ></el-table-column>
    <el-table-column prop="chargeTime" label="迁入日期"  ></el-table-column>
    <el-table-column prop="checkInDate" label="开始收费日期"  ></el-table-column>
    <el-table-column prop="roomType" label="房屋性质"  ></el-table-column>
  </el-table>
        <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px;">
    </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import BillStorageDialog from "../common/BillStorageDialog";
import choiceTree from "../common/choiceTree.vue";

export default {
  name: "ReceivableBill",
  components: {BillStorageDialog,choiceTree},
  data() {
    return {
      osData:[],
      loading:false,
      ChargeItemChoice:[],
        total:0,//默认数据总数
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        BillDateVal:"",
         props: { multiple: true },
         propss:{multiple: true},
      tableData: [],
      options: [],
        value: '',
        ChargeItemList:[],
        ChargeItemvalue:"",
        HouseNatureList:[],
        HouseNaturevalue:"",

      diaLogVisible: false,
      diaLogData: {
        diaLogVisible: false,
        diaLogType: '',
        paramObj: {},
        paramList: [],
      },
      AllData:"",
      taxRateval:[],
      RoomNature:[],
      RoomArr:[],
      HouseArr:[],

      projectIds:[],
      floorIds:[],
      idDate:{},

      projectId:"",
      startDate:"",
      endDate:"",
    }
  },
  methods: {
        handleSizeChange(val) {
      this.pagesize = val
        this.ShareList()
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.ShareList()
    },
      ChanHouseNature(val){
        let arr =[]
        for(let res of val){
          arr.push(res[0])
        }
        // 选择房屋性质
        this.RoomNature = arr

      },
      ChargeItemL(val){
        let arr =[]
        for(let res of val){
          arr.push(res[0])
        }
          this.ChargeItemChoice = arr
          // 选择收费项目
      },
      BillDate(){
        // 选择时间
          let date = this.BillDateVal[0];
        let year = date.getFullYear();
	    	let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1 ): date.getMonth() + 1
        this.startDate = year+"-"+month
        let datetime = this.BillDateVal[1];
        let yeartime = datetime.getFullYear();
	    	let monthtime = datetime.getMonth() + 1 < 10 ? '0' + (datetime.getMonth() + 1 ): datetime.getMonth() + 1
        this.endDate = yeartime+"-"+monthtime
      },
      BillNucleu(val){
        // console.log(val)
          let ownerIds = []
          let roomIds = []
          for(let obj of val){
            ownerIds.push(obj.customerId)
            roomIds.push(obj.roomId)
          }
          this.RoomArr = roomIds // 房间id
          this.taxRateval = ownerIds  // 业主id
      },
    getMsgFormSon(data){
      this.idDate = data
      if(data == false){
        this.tableData = []
        this.total = 0
      }else{
      this.ergodic(data)
      }
    },
    ergodic(data){
        let arr = []
        let array = []
        let arraylist = []
      if(data.children!=null && data.orgId == null){
        for(let val of data.children){
          arr.push(val.id)
          if(val.children!=null && val.orgId !=null ){
            for(let list of val.children){
              arraylist.push(list.id)
              this.floorIds = arraylist
            }
          }
        }
        this.projectIds = arr
      }else if(data.orgId!=null){
        let arr = []
        let array = []
        arr.push(data.id)
        this.projectIds = arr
        if(data.children != null){
          for(let val of data.children){
            array.push(val.id)
          }
        }
        this.floorIds = array
      }else{
        let res = this.osData
        this.ergodicity(res,data.id)
        let arrdata = []
        arrdata.push(data)
        for(let val of arrdata){
          array.unshift(val.id)
        }
        this.floorIds = array
      }
      this.ShareList()
    },
    ergodicity(res,id){
      let arr = []
      for(let val of res){
        if(val.children!=null){
          for(let valc of val.children){
            if(valc.children !=null){
              for(let valch of valc.children){
                if(valch.id == id){
                  arr.push(valc.id)
                }
              }
            }
          }
        }
      }
      this.projectIds = arr
    },
    ShareList(){
          let PageSize = {
            "page":this.currentPage, // 当前页
            "size":this.pagesize,  // 每页大小
            "floorIds":this.floorIds,
            "projectIds":this.projectIds
          }
        this.$http.post(this.$requestUrl.POST_BILLLIST,PageSize).then((res) => {
          let data = res.data;
          if (200 === data.code){
            this.total = data.data.total
            this.traversal(data.data.records)
            this.tableData = data.data.records;
            this.loading = false
          } else {
            this.$message.error(result.msg)
            this.loading = false
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
    },
    traversal(res){
      for(let date of this.HouseArr){
        for(let val of res){
          if(date.value == val.roomproperty){
              val.roomType = date.label
          }
        }
      }
    },

    CreateBill(){ 
        // 生成账单
      let arr = []
      arr.push(this.idDate)
      for(let val of arr ){
        if(val.orgId != null){
          let arrval = []
          arrval.push(val)
          for(let val of arrval){
            this.projectId = val.id
            if(val.children.length>0){
              let valid = []
              for(let valch of val.children){
                valid.push(valch.id)
              }
            }
          }
        }else{
          for(let res of this.osData){
            if(res.children != null){
              for(let resc of res.children){
                if(resc.children!=null){
                  for(let resch of resc.children){
                    if(resch.id == val.id){
                      this.projectId = resc.id
                    }
                  }
                }
              }
            }
          }
        }
      }
     if(this.projectId.length>0){
          if(this.startDate.length>0 && this.endDate.length>0){
            if(this.ChargeItemChoice !=null && this.ChargeItemChoice !=[] &&this.ChargeItemChoice.length >0){
              if(this.RoomNature !=null && this.RoomNature !=[]&& this.RoomNature.length >0){
                if(this.RoomArr!=null && this.RoomArr !=[]&& this.RoomArr.length >0){
                  let obj = {
                    "feecodes":this.ChargeItemChoice,
                    "propertys":this.RoomNature,
                    "ownerIds":this.taxRateval,
                    "roomIds":this.RoomArr,
                    "startDate":this.startDate,
                    "endDate":this.endDate,
                    "projectId":this.projectId,
                  }
                    this.$http.post(this.$requestUrl.POST_CREATE_BILL,obj).then((res) => {
                    let data = res.data;
                    if (200 === data.code){
                      this.$message({
                        message: "账单生成："+res.data.msg+";账单生成成功!",
                        type: 'success'
                      });
                      this.ShareList()
                    } else {
                       this.$message({
                        message: res.data.msg,
                        type: 'warning'
                      });
                      this.ShareList()
                    }
                  }).catch(() => {
                    this.$message.error(this.$errorMessage.SEVER_ERROR)
                  })
                }else{
                  this.$message({
                    message: '房间不能为空！',
                    type: 'warning'
                  });
                  // 房间不能为空！
                }
              }else{
                this.$message({
                  message: '房屋性质不能为空！',
                  type: 'warning'
                });
                // 房屋性质不能为空！
              }
            }else{
              this.$message({
                message: '收费项目不能为空！',
                type: 'warning'
              });
              //收费项目不能为空！
            }
          }else{
            this.$message({
              message: '年限范围不能为空！',
              type: 'warning'
            });
            // 年限范围不能为空！
          }
        }else{
          this.$message({
            message: '请选择项目信息！',
            type: 'warning'
          });
          // 请选择项目信息！
        }

    },
    ChargeItem(){
        this.$http.get(this.$requestUrl.GET_ITEM_TYPE).then((res)=>{
            let arr = []
            for(let val of res.data.data){
                    let obj = {
                        "value":val.feeCode,
                        "label":val.feeName,
                    }
                    arr.push(obj)
                }
                this.ChargeItemList = arr
        })
    },
    HouseNature(){
        let obj = {
            "page":1,
            "size":30,
            "type":"room_property"
        }
         this.$http.post("/sys/web/dict/get/list",obj).then((res)=>{
            let arr = []
            this.HouseArr = res.data.data.records
            for(let val of res.data.data.records){
                    let obj = {
                        "value":val.id,
                        "label":val.label,
                    }
                    arr.push(obj)
            }
             this.HouseNatureList = arr
        })
    },
        getUserOffice() {
      this.$http.get(this.$requestUrl.GET_FLOOR_TREE).then((res) => {
        let data = res.data.data;
          this.osData = data
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
    },

  },
  mounted() {
    this.getUserOffice()
    this.ChargeItem()
    this.HouseNature()
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;

    }
  }

}
.el-cascader-node__label{
  color: black;
}
</style>